import {CurrentQuoteWidget} from "./widgets/current-quote";


export const widgets = {
  "quote:current-quote": CurrentQuoteWidget,
};
